import { memo } from 'react';
import { KeyboardLayouts } from '../../SimpleKeyboard/Layout';
import { isElectron } from '../../../helpers/EnvironmentFlags/EnvironmentFlags';
import { KioskFormTagNumberField } from './KioskFormTagNumberField/KioskFormTagNumberField';
import { WebFormTagNumberField } from './WebFormTagNumberField/WebFormTagNumberField';
import { FormTagNumberFieldProps } from './FormTagNumberField.types';

const FormTagNumberField = memo(({
    name,
    id,
    title,
    label,
    ariaLabel,
    disabled,
    required = false,
    autoFocus,
    keyboardLayout = KeyboardLayouts.Alphanumeric,
    shiftAfterSpace = false,
    shiftAfterPeriod = false,
    hideKeyboardOnClickOut = false,
    capsLock = false,
    fullWidth = false,
    seventyFivePercentWidth = false,
    tabFocusRefContext,
    onChangeCallback,
}: FormTagNumberFieldProps) => {

    return (
        isElectron() ? (
            <KioskFormTagNumberField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                keyboardLayout={keyboardLayout}
                shiftAfterSpace={shiftAfterSpace}
                shiftAfterPeriod={shiftAfterPeriod}
                hideKeyboardOnClickOut={hideKeyboardOnClickOut}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
            />
        ) : (
            <WebFormTagNumberField
                name={name}
                id={id}
                title={title}
                label={label}
                ariaLabel={ariaLabel}
                disabled={disabled}
                required={required}
                autoFocus={autoFocus}
                capsLock={capsLock}
                fullWidth={fullWidth}
                seventyFivePercentWidth={seventyFivePercentWidth}
                tabFocusRefContext={tabFocusRefContext}
                onChangeCallback={onChangeCallback}
            />
        )
    );
});

export default FormTagNumberField;
